export default {
  女装: "အမျိုးသမီးအဝတ်အစား",
  男装: "အမျိုးသားများအတွက်",
  手机和小工具: "မိုဘိုင်းဖုန်းနှင့်သေးငယ်တဲ့ကိရိယာများ",
  居家生活: "အိမ်",
  电脑及周边设备: "ကွန်ပျူတာနှင့်အရံပစ္စည်းကိရိယာများ",
  美容及个人护理: "အလှအပနှင့်ပုဂ္ဂိုလ်ရေးစောင့်ရှောက်မှု",
  家用电器: "စက်ကရိယာ",
  健康与保健: "ကျန်းမာရေးနှင့်ကျန်းမာရေးစောင့်ရှောက်မှု",
  食品和饮料: "အစားအစာနှင့်သောက်စရာ",
  玩具_儿童和婴儿: "ကစားစရာများ, ကလေးများနှင့်ကလေးငယ်များ",
  童装时尚: "ကလေးများအဝတ်အစားဖက်ရှင်",
  视频游戏: "ဗီဒီယိုဂိမ်းများ",
  运动与户外: "လေ့ကျင့်ခန်းနှင့်ပြင်ပ",
  爱好与书籍: "ဝါသနာများနှင့်စာအုပ်များ",
  相机和无人机: "ကင်မရာနှင့်မောင်းသူမဲ့လေယာဉ်များ",
  宠物食品及用品: "အိမ်မွေးတိရစ္ဆာန်အစားအစာနှင့်ထောက်ပံ့ရေးပစ္စည်းများ",
  女士包袋: "အမျိုးသမီးအိတ်",
  男士包袋: "အမျိုးသားအိတ်",
  珠宝及配饰: "လက်ဝတ်ရတနာများနှင့်ဆက်စပ်ပစ္စည်းများ",
  手表: "စောင့်",
  女鞋: "အမျိုးသမီးစီးဖိနပ်",
  男装鞋: "အမျိုးသားစီးဖိနပ်",
  汽车: "ကား",
  我附近的ShopeePay: "ငါ့အနီးအနားရှိစျေးဆင်",
  餐饮_旅行和服务: "Catering, ခရီးသွားခြင်းနှင့်ဝန်ဆောင်မှု",
  旅行及行李: "ခရီးသွားခြင်းနှင့်ခရီးဆောင်အိတ်များ",
  各种各样的: "အမျိုးမျိုးသော",
  我是来买什么的: "ငါဝယ်ဖို့ဒီမှာပါ",
  对不起_找不到_相关的商品:
    "စိတ်မကောင်းပါ, ဆက်စပ်သောထုတ်ကုန်များကိုသင်ရှာမတွေ့ပါ",
  类别: "အမျိုးအစား",
  产品: "အထွက်ပစ္စည်းများ",
  店铺: "ကုန်ဆိုင်",
  首页: "ရှေ့စာမျက်နှာ",
  限时秒杀: "ကန့်သတ်အချိန် Spike",
  博客: "ဘလော့",
  所有品牌: "အားလုံးအမှတ်တံဆိပ်",
  所有类别: "အမျိုးအစားအားလုံး",
  我的购物车: "ငါ့စျေးဝယ်လှည်း",
  发货信息: "ပေးပို့သတင်းအချက်အလက်",
  交货信息: "ပေးပို့သတင်းအချက်အလက်",
  付款: "ပေးဆောင်ခြင်း",
  确认: "အတည်ပြု",
  您的购物车是空的: "သင်၏စျေးဝယ်လှည်းသည်ဗလာဖြစ်သည်",
  价格: "စြေး",
  税: "အခွန်",
  数量: "အရေအတွက်",
  总计: "လုံးဝသော",
  移除: "ရေွှ့",
  返回商店: "စတိုးဆိုင်သို့ပြန်သွားပါ",
  继续发货: "ဆက်လက်ပေးပို့",
  筛选: "စိမ့်ထွက်",
  价格范围: "စြေး",
  排序方式: "အလိုက်စဥ်သည်",
  最新: "နောက်ဆုံးပေါ်",
  最旧: "အိုသော",
  价格从低到高: "အနိမ့်ကနေမြင့်မားဖို့စျေးနှုန်း",
  价格从高到低: "အမြင့်မှနိမ့်အထိစျေးနှုန်း",
  选择交货类型: "Delivery အမျိုးအစားကိုရွေးချယ်ပါ",
  送货上门: "ပို့ခြင်း",
  继续付款: "ငွေပေးချေရန်ဆက်လက်",
  任何其他信息: "အခြားမည်သည့်သတင်းအချက်အလက်မဆို",
  或者: "သို့မဟုတ်",
  您的钱包余额: "သင်၏ပိုက်ဆံအိတ်လက်ကျန်ငွေ",
  余额不足: "မလုံလောက်ချိန်ခွင်လျှာ",
  支付: "အခပေး",
  我同意: "ကျွန်တော်သဘောတူသည်",
  条款和条件: "စည်းကမ်းနှင့်သတ်မှတ်ချက်များ",
  退货政策: "ပြန်လည်ပေးပို့ခြင်းဆိုင်ရာမူဝါဒ",
  隐私政策: "လှျို့ဝှက်ချက်",
  概括: "ပေါင်း",
  项目: "အကြံအစည်",
  全部的: "အားလုံး - အသံထွက်",
  小计: "အကြမ်းပုံ",
  总运费: "စုစုပေါင်းကုန်တင်",
  有优惠码吗_在这里输入: "လျှော့စျေးကုဒ်ရှိပါသလား ဒီမှာရိုက်ထည့်ပါ",
  申请: "လေှျာက်တောင်း",
  编辑: "ပုံနှိပ်ရန်ပြင်ဆင်ရေးသား",
  删除: "ဖျက်",
  添加新地址: "လိပ်စာအသစ်ထည့်ပါ",
  继续交货信息: "ပေးပို့သတင်းအချက်အလက်ဆက်လက်",
  选择一个地址: "လိပ်စာတစ်ခုရွေးပါ",
  购买历史: "သမိုင်းကိုဝယ်ပါ",
  下载: "ဒေါက်ဒေါင်း",
  已发送退款请求: "ပြန်အမ်းငွေတောင်းဆိုမှုသည်ပြန်အမ်းငွေတောင်းဆိုမှုကိုပို့သည်",
  对比: "ခြားနား",
  对话: "တွေ့ဆုံဆမှု",
  我的钱包: "ငါ့ပိုက်ဆံအိတ်",
  工单: "အလုပ်အမိန့်",
  管理个人资料: "ကိုယ်ရေးကိုယ်တာအချက်အလက်ကိုစီမံပါ",
  登出: "ဆိုင်းအောက်",
  重置对比列表: "နှိုင်းယှဉ်စာရင်းပြန်လည်သတ်မှတ်",
  您的对比列表为空: "သင့်ရဲ့နှိုင်းယှဉ်စာရင်းဗလာဖြစ်ပါတယ်",
  在您的购物车中: "သင့်ရဲ့စျေးဝယ်လှည်း၌",
  在您的愿望清单中: "သင့်ရဲ့ဆန္ဒစာရင်းတွင်",
  在您的预定列表中: "သင့်ရဲ့စီစဉ်ထားစာရင်းတွင်",
  下载您的产品: "သင်၏ကုန်ပစ္စည်းကိုဒေါင်းလုပ်ဆွဲပါ",
  选项: "ရေှးယူခွင့်",
  什么都没找到: "ငါဘာမျှမတွေ့ရှိခဲ့",
  特色产品: "အထူးထုတ်ကုန်",
  最畅销: "အကောင်းဆုံး -selling",
  前_名: "{0} အမည်",
  查看更多: "ထပ်မံကြည့်ရန်",
  查看所有类别: "အမျိုးအစားအားလုံးကိုကြည့်ပါ",
  十大品牌: "ထိပ်တန်းအမှတ်တံဆိပ်ဆယ်ခု",
  查看所有品牌: "ကုန်အမှတ်တံဆိပ်အားလုံးကိုကြည့်ပါ",
  登录: "လော့ဂ်အင်",
  手机号码: "ဖုန်းနံပါတ်",
  密码: "လှျို့ဝှက်စကား",
  密码长度为6到16个字符: "စကားဝှက်အရှည်သည် 6 မှ 16 လုံးအထိဖြစ်သည်",
  验证码: "အတည်ပြုရန်ကုတ်",
  登录中: "လော့ဂ်အင်",
  游客登录: "ခရီးသွား Login",
  注册您的商店: "သင်၏စတိုးဆိုင်ကိုမှတ်ပုံတင်ပါ",
  现在申请: "ယခု Apply",
  成为商家: "ကုန်သည်ဖြစ်လာသည်",
  现在注册: "ယခုမှတ်ပုံတင်ပါ",
  登录成功: "ဝင်လာသော login",
  通知: "ကြားသိပါ",
  未找到通知: "အသိပေးချက်မရှိပါ",
  评论: "commentီကာ",
  估计运输时间: "သယ်ယူပို့ဆောင်ရေးအချိန်ခန့်မှန်း",
  天: "မိုးကောင်းကင်",
  所售: "ရောင်းချခြင်း",
  给商家留言: "ကုန်သည်ထံသို့စာတစ်စောင်ချန်ထားပါ",
  规格: "အသေးစိတ်အချက်အလက်",
  库存: "ကုန်ပစ္စည်းလက်ဝယ်ရှိ",
  总价: "အထွေထွေစျေးနှုန်း",
  添加到购物车: "စျေးဝယ်ခြင်းထဲသို့ထည့်သည်",
  立即购买: "အခုဝယ်ပါ",
  缺货: "ပစ္စည်းပြတ်တောက်နေသည်",
  添加到愿望清单: "ဆန္ဒစာရင်းထဲသို့ထည့်ပါ",
  加入对比列表: "နှိုင်းယှဉ်စာရင်းထည့်ပါ",
  退款: "ပြန်ပေး",
  查看条款: "အပိုဒ်ကိုကြည့်ပါ",
  分享: "ခဲှဝေ",
  描述: "ဖေါ်ပြ",
  相关产品: "ဆက်စပ်ထုတ်ကုန်များ",
  没有人问过商家: "ကုန်သည်ကိုဘယ်သူမှမမေးဘူး",
  该产品暂无评论: "ဒီထုတ်ကုန်အပေါ်မှတ်ချက်မရှိပါ",
  客户评论: "ဖောက်သည်မှတ်ချက်",
  访问商店: "စတိုးဆိုင်လည်ပတ်",
  畅销产品: "အကောင်းဆုံး - ထုတ်ကုန်များ",
  日期: "နေ့စဲှ",
  订单编号: "အော်ဒါနံပါတ်",
  总额: "တစ်ပေါင်းတည်းပေးသောငွေ",
  状态: "အသေအချာပေြာဆို",
  愿望清单: "List",
  还没有添加任何东西: "သေးဘာမှမထည့်သေးဘူး",
  注册: "စာရင်း",
  邀请码: "ဖိတ်ကြားချက်ကုဒ်",
  请输入邀请码: "ကျေးဇူးပြု. ဖိတ်ကြားချက်ကုဒ်ရိုက်ထည့်ပါ",
  用户名: "အသုံးပြုသူ",
  请输入用户名: "ကျေးဇူးပြု. အသုံးပြုသူအမည်ကိုရိုက်ထည့်ပါ",
  用户名长度为6_14个字符: "အသုံးပြုသူအမည်အရှည်မှာ 6-14 ဇာတ်ကောင်ဖြစ်သည်",
  昵称: "nick nick",
  请输入手机号码: "ကျေးဇူးပြု. လက်ကိုင်ဖုန်းနံပါတ်ကိုရိုက်ထည့်ပါ",
  手机号码格式错误: "မိုဘိုင်းဖုန်းဖုန်းနံပါတ်ပုံစံအမှား",
  密码长度为6_16个字符: "စကားဝှက်အရှည် 6-16 ဇာတ်ကောင်ဖြစ်ပါတယ်",
  确认密码: "စကားဝှက်အတည်ပြုခြင်း",
  请输入确认密码: "ကျေးဇူးပြု. အတည်ပြုချက်စကားဝှက်ကိုရိုက်ထည့်ပါ",
  提款密码: "ဆုတ်ခွာစကားဝှက်",
  请输入提款密码: "ကျေးဇူးပြုပြီးဆုတ်ခွာစကားဝှက်ကိုရိုက်ထည့်ပါ",
  提款密码长度为4_16个字符: "ဆုတ်ခွာစကားဝှက်၏အရှည်သည်စာလုံး 4 နှစ်မှ 16 လုံးပါ",
  请输入验证码: "ကျေးဇူးပြု. အတည်ပြုကုဒ်ကိုရိုက်ထည့်ပါ",
  在_s后发送: "{0} s ကိုပြီးနောက်ပေးပို့ပါ",
  发送验证码: "အတည်ပြုကုဒ်ကိုပေးပို့ပါ",
  注册即表示您同意我们的条款和条件:
    "မှတ်ပုံတင်ခြင်းဆိုသည်မှာကျွန်ုပ်တို့၏စည်းကမ်းချက်များကိုသင်သဘောတူသည်။",
  创建账号: "အကောင့်တစ်ခုဖန်တီးသည်",
  验证码发送成功: "အတည်ပြုကုဒ်အောင်မြင်စွာပေးပို့",
  确认密码不一致: "စကားဝှက်သည်ကိုက်ညီမှုမရှိပါကအတည်ပြုပါ",
  提款密码必须为数字: "ထုတ်ယူသောစကားဝှက်ကိုရေတွက်ရမည်",
  注册成功: "အောင်မြင်စွာမှတ်ပုံတင်ပါ",
  购物车: "စျေးဝယ်လှည်း",
  账户: "ငေှစာရင်း",
  我的账户: "ကြှနျုပျအကောငျ့",
  已经有一个账户: "အကောင့်ရှိပြီးသားရှိသည်",
  新地址: "လိပ်စာအသစ်",
  编辑地址: "အယ်ဒီတာလိပ်စာ",
  保存: "ကယ်ဆယ်",
  是否默认: "ပျက်ကွက်ဖို့ရှိမရှိ",
  具体地址: "သတ်သတ်မှတ်မှတ်လိပ်စာ",
  请输入具体地址: "ကျေးဇူးပြု. သတ်သတ်မှတ်မှတ်လိပ်စာကိုထည့်ပါ",
  地区: "မေြရာ",
  请输入地区: "ကျေးဇူးပြုပြီး area ရိယာကိုရိုက်ထည့်ပါ",
  城市: "မြို့",
  请输入城市: "ကျေးဇူးပြုပြီးမြို့ကိုဝင်ပါ",
  省份: "နယ်ပယ်",
  请输入省份: "ကျေးဇူးပြုပြီးပြည်နယ်ကိုဝင်ပါ",
  邮政编码: "စာတိုက်သင်္ကေတ",
  请输入邮政编码: "ကျေးဇူးပြု. စာတိုက်ကုဒ်ကိုထည့်ပါ",
  电话号码: "တယ်လီဖုန်းနံပါတ်",
  请输入电话号码: "ကျေးဇူးပြု. ဖုန်းနံပါတ်ထည့်ပါ",
  收货人: "ပစ္စည်းြာ်သူ",
  请输入收货人: "ကျေးဇူးပြုပြီးလက်ခံသူကိုရိုက်ထည့်ပါ",
  保存成功: "အောင်မြင်ပါ",
  最畅销的商家: "အကောင်းဆုံး -selling ကုန်သည်",
  查看所有的商家: "ကုန်သည်များအားလုံးကိုစစ်ဆေးပါ",
  支持政策: "ပံ့ပိုးမှုမူဝါဒ",
  您的电子邮件地址: "သင့်အီးမေးလ်လိပ်စာ",
  订阅: "သတင်းစာမှာခြင်း",
  联系方式: "ဆက်သွယ်ရန်အချက်အလက်များ",
  地址: "စကားပေြာဟော",
  美国伊利诺伊州霍夫曼庄园: "Holfman Manor, အီလီနွိုက်ပြည်နယ်, USA",
  快速链接: "အမြန် link ကို",
  商家政策: "ကုန်သည်မူဝါဒ",
  submit: "နားထောင်",
  提款银行卡: "adbb ကဒ်",
  我的面板: "ငါ့ panel",
  提示: "စကားရိပ်",
  确定登出吗: "သင် log in လုပ်ထားပါသလား",
  确定: "စိတ်ချသော",
  取消: "ပျက်စေ",
  项目添加到您的购物车: "စီမံကိန်းကိုသင်၏စျေးဝယ်လှည်းထဲသို့ထည့်သွင်းထားသည်",
  经常一起购买: "မကြာခဏဝယ်ပါ",
  返回购物: "စျေးဝယ်ပြန်လာ",
  进行结算: "ငွေရှင်းရန်ဆက်လုပ်ပါ",
  帮助热线: "Hotline ကိုကူညီပါ",
  查看所有通知: "အသိပေးချက်အားလုံးကိုစစ်ဆေးပါ",
  请输入密码: "ကျေးဇူးပြု. စကားဝှက်ကိုရိုက်ထည့်ပါ",
  前往充值: "အားသွင်းဖို့သွားပါ",
  购物车物品: "စျေးဝယ်လှည်း",
  查看购物车: "စျေးဝယ်လှည်းကိုစစ်ဆေးပါ",
  钱包余额: "ပိုက်ဆံအိတ်လက်ကျန်ငွေ",
  充值钱包: "အိတ်ကိုသွင်းပါ",
  钱包充值_线下_: "Wallet Recharge (offline)",
  申请提款: "ဆုတ်ခွာလျှောက်ထား",
  钱包收支明细: "ပိုက်ဆံအိတ်ဝင်ငွေနှင့်အသုံးစရိတ်အသေးစိတ်",
  批准: "သဘောကြိုက်ညီ",
  提现历史记录: "စုဆောင်းမှုသမိုင်းစံချိန်",
  类型: "ပုံနှိပ်စာ",
  信息: "အကေြာင်းကြားချက်",
  付款方式: "ငွေပေးချေစနစ်",
  请选择付款方式: "ကျေးဇူးပြု. ငွေပေးချေမှုနည်းလမ်းကိုရွေးချယ်ပါ",
  Bill_Type_RECHARGE_BACK: "နောက်ခံငွေကြေး",
  Bill_Type_RECHARGE_ONLINE: "အွန်လိုင်းငွေသွင်းခြင်း",
  Bill_Type_RECHARGE_REGISTER: "စာရင်း",
  Bill_Type_RECHARGE_JACKPOT: "ရေွှ",
  Bill_Type_RECHARGE_PRESENT: "revhewarge ဆု",
  Bill_Type_RECHARGE_FROM_COMMISSION: "ကော်မရှင်လွှဲပြောင်း",
  Bill_Type_RECHARGE_TG_COMMISSION: "အားသွင်း Promotion ကော်မရှင်ကိုအားသွင်းပါ",
  Bill_Type_REGISTER_TG_COMMISSION: "မှတ်ပုံတင်ခြင်းနှင့်မြှင့်တင်ရေးကော်မရှင်",
  Bill_Type_WITHDRAW: "ဆုတ်ခွာ",
  Bill_Type_WITHDRAW_REJECT: "ဆုတ်ခွာ",
  Bill_Type_DEDUCT_HANDLE: "လက်စွဲစာအုပ်နှုတ်ယူခြင်း",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "ရေွှ",
  Bill_Type_MINING_PROFIT: "သတ္တုတွင်းဝင်ငွေ",
  Bill_Type_MINING_PROFIT_COMMISSION: "သတ္တုတွင်းဝင်ငွေမြှင့်တင်ရေးကော်မရှင်",
  Bill_Type_VIP_UPGRADE: "အဆင့်မြှင့်တင်ခြင်း VIP",
  Bill_Type_FINANCE_BUY: "စည်းစိမ်ဥစ်စာစီမံခန့်ခွဲမှုကုန်ပစ္စည်းဝယ်ယူ",
  Bill_Type_FINANCE_CAPITAL_RETURN: "ဘဏ် financial ာရေးလက်ကျန်ငွေပြန်လာ",
  Bill_Type_FINANCE_FEE: "ဘဏ် financy ာရေးကိုင်တွယ်ကြေး",
  Bill_Type_FINANCE_PROFIT: "ဘဏ်ာရေးဝင်ငွေ",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "စည်းစိမ်ဥစ်စာစီမံခန့်ခွဲမှုထုတ်ကုန်များအတွက်ကော်မရှင်များဝယ်ယူ",
  Bill_Type_FINANCE_PROFIT_COMMISSION:
    "စည်းစိမ်ဥစ်စာစီမံခန့်ခွဲမှုကုန်ပစ္စည်းဝင်ငွေကော်မရှင်",
  Bill_Type_WHEEL_DRAW: "ကြီးမားသော turntable raffle",
  Bill_Type_BUY: "ကုန်ပစ္စည်းများဝယ်ပါ",
  Bill_Type_PAY_SHOP: "ငွေပေးချေ",
  Bill_Type_BUY_COMMISSION: "ကုန်ပစ္စည်းကော်မရှင်ကို 0 ယ်ပါ",
  Bill_Type_DEPOSIT: "ငွေသွင်းပါ",
  Bill_Type_STORE_BUY: "ကုန်ပစ္စည်းများဝယ်ပါ",
  Bill_Type_STORE_BUY_REFUND: "ပြန်အမ်းငွေကိုဝယ်ပါ",
  Bill_Type: "အကြွေးပြောင်းလဲခြင်းအမျိုးအစား",
  Before_Money: "ယခင်ငွေပမာဏ",
  Deal_Money: "အကောင့်ပြောင်းလဲမှုပမာဏ",
  After_Money: "နောက်ဆက်တွဲငွေပမာဏ",
  Bill_Time: "အကောင့်အချိန်ပြောင်းချိန်",
  No_More_Data: "ဒေတာမရှိတော့ပါ",
  Apply_Money: "လျှောက်လွှာပမာဏ",
  Apply_Time: "လျှောက်လွှာအချိန်",
  Withdraw_Info: "ကိုင်တွယ်ကြေး: {ငွေကြေး} {ပိုက်ဆံ}",
  提款订单状态_CHECKING: "ပြန်လည်သုံးသပ်ခံရဖို့",
  提款订单状态_TRANSFERRING: "ပေြာင်းလဲွှ",
  提款订单状态_PASS: "အတည်ပြု",
  提款订单状态_REJECT: "ငြင်းပယ်ခဲ့သည်",
  暂无可用充值方式: "အသုံးဝင်သောအားသွင်းနည်းစနစ်မရှိပါ",
  钱包收款码: "ပိုက်ဆံအိတ်စုဆောင်းခြင်းကုဒ်",
  钱包地址: "ပိုက်ဆံအိတ်လိပ်စာ",
  金额限制: "ပမာဏကန့်သတ်ချက်",
  复制: "ကူးရေး",
  付款凭证: "ငွေပေးချေမှုဘောက်ချာ",
  收款银行: "လက်ခံရရှိသောဘဏ်",
  收款人: "ငေှကိုင်စာရေး",
  收款账号: "ငွေလက်ခံဖြတ်ပိုင်းအကောင့်",
  付款银行: "ဘဏ်",
  付款人: "ပေးဆောင်သူ",
  付款账号: "ငွေပေးချေမှုအကောင့်",
  请输入付款银行: "ကျေးဇူးပြုပြီးငွေပေးချေမှုဘဏ်ကိုရိုက်ထည့်ပါ",
  请输入付款人: "ကျေးဇူးပြုပြီးငွေပေးချေသူကိုရိုက်ထည့်ပါ",
  请输入付款账号: "ကျေးဇူးပြု. ငွေပေးချေမှုအကောင့်ကိုရိုက်ထည့်ပါ",
  请上传付款凭证: "ကျေးဇူးပြုပြီးငွေပေးချေမှုဘောက်ချာများကိုတင်ပါ",
  充值金额: "ငွေပမာဏကိုအားသွင်းပါ",
  请输入充值金额: "ကျေးဇူးပြု. ငွေဖြည့်ငွေပမာဏကိုထည့်ပါ",
  submitting: "တင်သွင်း ...",
  Confirm: "နားထောင်",
  Commit_Success: "အောင်မြင်ခဲ့တဲ့တင်ပြချက်",
  balanceType_BALANCE: "လက်ကျန်ငေှ",
  balanceType_COMMISSION: "လွှအပ်စာ",
  Balance: "အကောင့်လက်ကျန်ငွေ",
  Wash_Money: "ကုဒ်",
  请选择银行账户: "ကျေးဇူးပြုပြီးဘဏ်အကောင့်ကိုရွေးပါ",
  卡号类型: "ကဒ်နံပါတ်",
  提现金额: "ထုတ်ယူငွေပမာဏ",
  提款金额: "ထုတ်ယူငွေပမာဏ",
  不能为空: "ဗလာမဖြစ်နိုင်ဘူး",
  金额不正确: "မမှန်ကန်သောပမာဏ",
  please_input_withdraw_password: "ကျေးဇူးပြုပြီးဆုတ်ခွာစကားဝှက်ကိုရိုက်ထည့်ပါ",
  withdraw_password_format_error:
    "ထုတ်ယူသောစကားဝှက်သည် 4-16-bit အက္ခရာများဖြစ်ရမည်",
  Fee: "အခကြေးငွေ",
  实际到账: "မုချ",
  交易币种: "ကုန်သွယ်ငွေကြေး",
  原始密码: "Primitive Password",
  confirm_password_error: "သွင်းအားစုနှစ်ခု၌စကားဝှက်သည်မမှန်ကန်ပါ",
  save_success: "အောင်မြင်ပါ",
  please_input: "ကျေးဇူးပြု. ရိုက်ထည့်ပါ",
  old_password: "စကားဝှက်အဟောင်း",
  new_password: "စကားဝှက်အသစ်",
  please_input_confirm_password: "ကျေးဇူးပြု. စကားဝှက်ကိုပြန်အတည်ပြုပါ",
  没有找到符合条件的商品: "အရည်အချင်းပြည့်မီသောထုတ်ကုန်များကိုရှာမရပါ",
  Search: "ရှာဖေှခြင်း",
  全部: "အားလုံး",
  EnumGoodsOrderState_USER_PAY: "ဖြန့်ဝေခံရဖို့",
  EnumGoodsOrderState_SHOP_PAY: "ဝေခြမ်းခြင်း",
  EnumGoodsOrderState_SUCCESS: "အပြီးသတ်",
  EnumGoodsOrderState_CANCEL: "ပျက်စေ",
  EnumGoodsOrderState_REFUND_SUCCESS: "ပြန်ပေး",
  订单号: "အော်ဒါနံပါတ်",
  用户名称: "အသုံးပြုသူအမည်",
  收益: "ဝင်ငေှ",
  支付时间: "အချိန်ပေးပါ",
  配送时间: "ပို့ဆောင်ချိန်",
  完成时间: "ပြီးပြည့်စုံသောအချိန်",
  发货: "သငေ်္ဘာ",
  全选: "ရွေးချယ်မှုအပြည့်",
  物品已添加到愿望清单: "ပစ္စည်းများကိုဆန္ဒစာရင်းတွင်ထည့်သွင်းထားသည်",
  物品已添加到比较列表: "အဆိုပါပစ္စည်းများနှိုင်းယှဉ်စာရင်းမှထည့်သွင်းခဲ့ကြသည်",
  购买成功提示: "ဂုဏ်ယူပါတယ်, အောင်မြင်စွာဝယ်",
  订单列表: "အမိန့်စာရင်း",
  商品名: "ကုန်ပစ္စည်းအမည်",
  图片: "ရုပ်ပုံ",
  没有品牌: "အမှတ်တံဆိပ်မရှိပါ",
  基本信息: "အခြေခံသတင်းအချက်အလက်",
  Account_Name: "နံမယ်",
  Bank_Account: "ဘဏ်အကောင့်",
  Bank_Phone: "မိုဘိုင်းဖုန်းနံပါတ်ကိုကြိုတင်စာရင်းသွင်းပါ",
  IFSC: "IFSC အကောင့်",
  UPI: "UPI အကောင့်",
  PIX: "pix အကောင့်နံပါတ်",
  CPF: "CPF အကောင့်",
  GCASH: "GCash အကောင့်",
  POWWI: "Powwi အကောင့်",
  身份证号: "အိုင်ဒီနံပါတ်",
  Edit: "ပြန်လည်စစ်ဆေးကြည့်ရှု",
  Delete: "ဖျက်",
  Add: "တိုးမြှင့်လာသည်",
  Forget_Withdraw_Password: "ဆုတ်ခွာစကားဝှက်ကိုမေ့လျော့",
  Bank_Card_Info: "ဘဏ်ကဒ်အချက်အလက်",
  收款人地址: "ငွေကိုင်လိပ်စာ",
  SWIFT: "လျင်မြန်စွာ",
  Bank_Branch: "sub -branch အမည်",
  分行代码: "ဌာနခွဲကုဒ်",
  银行地址: "ဘဏ်လိပ်စာ",
  Email: "အီးမေးလ်",
  银行卡长度必须超过: "ဘဏ်ကဒ်သက်တမ်းသည် {{} ထက်ကျော်လွန်ရမည်ဖြစ်သည်။",
  银行卡格式不正确: "ဘဏ်ကဒ်ပုံစံသည်မမှန်ကန်ပါ",
  Do_you_confirm_delete: "ဖျက်ပစ်အတည်ပြုပါသလား",
  Please_Login_First: "ကျေးဇူးပြု. ပထမ ဦး ဆုံး log in လုပ်ပါ",
  Bank_Name: "ဘဏ်အမည်",
  Please_add_bank_first: "သင်ဘဏ်ကဒ်ပြားကိုမဖြည့်ပါနှင့်",
  withdrawType: "ဆုတ်ခွာ",
  withdraw_money_limit:
    "ဆုတ်ခွာပမာဏသည် 0 ထက်ကြီးမြတ်ပြီး {ချိန်ခွင်လျှာ} နှင့်ညီမျှရမည်။",
  withdraw_times_limit:
    "သငျသညျ {todesthwithdroubnum} The Times The Times ထုတ်ယူပါပြီ။ {limittime} ပြီးနောက် {limittime} ပြီးနောက်သင် {{စွန့်လွှတ်အနစ်နာခံမှု}% အားသွင်းပါလိမ့်မယ်။ ပိုက်ဆံထုတ်ယူဖို့စိတ်ပိုင်းဖြတ်ထားသလား။",
  Copy_Success: "ပွားခြင်း",
  商店首页: "ပင်မစာမျက်နှာသိုလှောင်",
  所有产品: "ထုတ်ကုန်အားလုံး",
  新到货产品: "အသစ် -arrover ထုတ်ကုန်",
  所有商家: "ကုန်သည်အားလုံး",
  请上传: "ကျေးဇူးပြုပြီးတင်ပါ",
  请输入: "ကျေးဇူးပြု. ရိုက်ထည့်ပါ",
  忘记密码: "စကားဝှက်ကိုမေ့လိုက်ပါ",
  记得我: "ကျွန်တော့်ကိုမှတ်မိပါသလား",
  共_件: "စုစုပေါင်း {0} အပိုင်းအစ",
  取消订单: "ပယ်ဖျက်ရန်",
  申请退款: "ပြန်အမ်းငွေအတွက်လျှောက်ထားပါ",
  未知商家: "အမည်မသိကုန်",
  到账: "ငေှစာရင်း",
  提款订单状态: "ဆုတ်ခွာအမိန့်အခြေအနေ",
  前_名类别: "အမျိုးအစားပထမအမျိုးအစား {0}",
  取消订单原因_不想要了: "တော့ဘူးမရှိတော့ဘူး",
  取消订单原因_商品错选_多选:
    "ထုတ်ကုန်အမှားများ / ရွေးချယ်မှုမျိုးစုံရွေးချယ်မှု",
  取消订单原因_商品无货: "-of -good",
  取消订单原因_地址信息填写错误: "လိပ်စာအချက်အလက်အမှားကိုဖြည့်ပါ",
  取消订单原因_商品降价: "ကုန်စည်စျေးနှုန်းလျှော့ချရေး",
  取消订单原因_价格高于其他平台:
    "စျေးနှုန်းသည်အခြားပလက်ဖောင်းများထက်ပိုမိုမြင့်မားသည်",
  取消订单原因_没用_少用_错用优惠:
    "အဘယ်အရာကိုမျှ / အသုံးမပြုပါ / အမှားလျှော့စျေး",
  退款原因_拍错_多拍_不喜欢: "မှား / ရိုက်ကူးပါ / မကြိုက်ပါ",
  退款原因_商品成分描述不符:
    "ထုတ်ကုန်အစိတ်အပိုင်းဖော်ပြချက်ဖော်ပြချက်မကိုက်ညီပါ",
  退款原因_与商家协商一致退款: "ကုန်သည်ပြန်အမ်းငွေနှင့်တိုင်ပင်ဆွေးနွေး",
  退款原因_生产日期_保质期与商品描述不符:
    "ထုတ်လုပ်မှုနေ့ / စင်ပေါ်ဘဝသည်ကုန်ပစ္စည်းဖော်ပြချက်နှင့်မကိုက်ညီပါ",
  退款原因_图片_产地_批号_规格等描述不符:
    "Image / Batch နံပါတ် / သတ်မှတ်ချက်များစသည်တို့ imc.",
  退款原因_质量问题: "အရည်အသွေးပြ issue နာ",
  退款原因_商品变质_发霉_有异物:
    "ကုန်ပစ္စည်းများပျက်စီး / မှို / နိုင်ငံခြားခန္ဓာကိုယ်",
  退款原因_少件_含缺少配件_:
    "ပစ္စည်းအနည်းငယ်သာ (ဆက်စပ်ပစ္စည်းများ၏မရှိခြင်းအပါအ 0 င်)",
  退款原因_收到商品时有破损_污渍_变形:
    "ထုတ်ကုန်ကိုလက်ခံရရှိသည့်အခါပျက်စီးဆုံးရှုံးမှု / အစွန်းအထင်း / ပုံပျက်သောရှိသည်",
  退款原因_假冒品牌: "တုပပြုလုပ်ထားသော",
  退款原因_发票问题: "ငွေတောင်းခံလွှာပြ problem နာ",
  退款原因_商家发错货:
    "ကုန်သည်များသည်ကုန်ပစ္စည်းများမှားယွင်းသောကုန်ပစ္စည်းများပို့သည်",
  退款原因_预约不到_商家不给退换: "ရက်ချိန်းယူပြီးကုန်သည်ကိုမပြန်နိုင်ပါ",
  退款失败: "ပြန်အမ်းငွေကြေး",
  退款处理中: "ပြန်အမ်းငွေအပြောင်းအလဲနဲ့",
  默认: "ပျက်ကွက်ခြင်း",
  产品查询: "ကုန်ပစ္စည်းစုံစမ်းမှု",
  商店LOGO: "ဆိုင်လိုဂိုစျေး",
  推广码: "အရောင်းမြှင့်တင်ရေးကုဒ်",
  查看所有: "အားလုံးစစ်ဆေးပါ",
  确认收货成功: "လက်ခံရရှိအောင်မြင်သောကြောင်းအတည်ပြုပါ",
  物流公司: "ထောက်ပံ့ပို့ဆောင်ရေးကုမ္ပဏီ",
  物流单号: "ထောက်ပံ့ပို့ဆောင်ရေးအမိန့်နံပါတ်",
  发货时间: "ပို့ဆောင်ချိန်",
  请先选择商品规格: "ကျေးဇူးပြု. ထုတ်ကုန်သတ်မှတ်ချက်ကို ဦး စွာရွေးချယ်ပါ",
  个人信息: "ကိုယ်ပိုင်သတင်းအချက်အလက်များ",
  您的用户名: "သင့်ရဲ့ Username",
  你的名字: "သင့်နာမည်",
  登录名: "အသုံးပြုသူ",
  你的邮件: "သင်၏မေးလ်",
  你的密码: "သင်၏စကားဝှက်",
  重复输入密码: "စကားဝှက်ကိုပြန်လုပ်ပါ",
  店铺名称: "ဆိုင်နာမည်",
  证书类型: "ပုံနှိပ်စာ",
  身份证: "အိုင်ဒီကဒ်",
  护照: "နိုင်ငံကူးလက်မှတ်",
  驾驶执照: "ယာဥ်မောင်းလိုင်စင်",
  社会保障卡: "လူမှုဖူလုံရေးကဒ်",
  证书正面: "အပြုသဘောဆောင်လက်မှတ်",
  证书反面: "သက်သေခံချက်",
  确认收货: "ကုန်ပစ္စည်းများလက်ခံရရှိအတည်ပြုပါ",
  请选择取消订单的原因必选:
    "ကျေးဇူးပြု. အမှာစာကိုပယ်ဖျက်ရန်အကြောင်းပြချက်ကိုရွေးချယ်ပါ။",
  请选择申请退款的原因必选:
    "ပြန်အမ်းငွေအတွက်လျှောက်ထားရသည့်အကြောင်းရင်းကိုရွေးချယ်ပါ (လိုအပ်သည်):",
  留言: "ပန်ကြားစာ",
  请输入留言: "ကျေးဇူးပြု. စာတစ်စောင်ထည့်ပါ",
  没有帐户: "အကောင့်မရှိပါ",
  钱包充值: "ပိုက်ဆံအိတ်အားသွင်း",
  输入您的文字: "သင့်ရဲ့စာသားကိုရိုက်ထည့်ပါ",
  商家登录: "ကုန်သည် login",
  有关此产品的任何查询: "ဒီထုတ်ကုန်အပေါ်မည်သည့်စုံစမ်းမှုမဆို",
  产品名称: "ကုန်ပစ္စည်းအမည်",
  你的问题: "မင်းရဲ့ပြ problem နာ",
  白银店铺: "ငွေဆိုင်",
  铂金店铺: "ပလက်တီနမ်ဆိုင်",
  钻石店铺: "စိန်ဆိုင်",
  照片: "ဓာတ်ပုံ",
  已退货: "ပြန်လာသော",
  邮寄状态: "မေးလ်အခြေအနေ",
  订单摘要: "အမိန့် abstraction",
  收件地址: "ဝင်ငွေလိပ်စာ",
  订购日期: "အမိန့်နေ့စွဲ",
  订单状态: "အမိန့်အခြေအနေ",
  总订单金额: "စုစုပေါင်းအမိန့်ပမာဏ",
  邮寄方式: "စာပို့နည်းလမ်း",
  附加信息: "နောက်ထပ်အချက်အလက်များ",
  订单详细信息: "အသေးစိတ်အချက်အလက်များ",
  交货类型: "ပေးပို့အမျိုးအစား",
  进行评论: "commentီကာ",
  已评论: "မှတ်ချက်ချ",
  订单金额: "အမိန့်ပမာဏ",
  优惠券: "ကူပွန်",
  统一运费: "Unified ကုန်တင်",
  送货地址: "ကုန်ပစ္စည်းပို့ဆောင်ရမည့်လိပ်စာ",
  评分: "နိုင်ပြီ",
  你的意见: "မင်းရဲ့ထင်မြင်ချက်",
  匿名: "အမည်မထုတ်ဖေါ်သော",
  现金: "ငေှလက်ငင်း",
  详情: "အသေးစိတ်",
  收货地址: "ငွေလက်ခံဖြတ်ပိုင်းလိပ်စာ",
  暂时没有对话: "ဖြစ်ရပ်အတွက်တွေ့ဆုံဆွေးနွေးမှုမရှိပါ",
  你: "ခင်ဗျားတို့",
  输入您的回复: "သင့်ရဲ့ပြန်ကြားချက်ရိုက်ထည့်ပါ",
  删除成功: "ဖျက်",
  品牌: "သံပူကပ်",
  已缴纳的保证金: "margin ပေးဆောင်",
  黄金店铺: "ရွှေဆိုင်",
  没有更多数据: "ဒေတာမရှိတော့ပါ",
  站内信: "-site အက်ခရာတွင်",
  系统通知: "စနစ်အသိပေးချက်",
  邮箱: "စာပို့",
  手机号: "ဖုန်းနံပါတ်",
  你的手机号: "သင့်ရဲ့လက်ကိုင်ဖုန်းနံပါတ်",
  营业执照: "လုပ်ငန်းလိုင်စင်",
  你的邮箱: "သင်၏စာတိုက်ပုံး",
  搜索结果: "ရှာဖွေမှုရလဒ်များ",
  系统公告: "စနစ်ကြေငြာချက်",
  客服: "ဧည့်ဝန်ဆောင်မှု",
  消息已撤回: "အဆိုပါသတင်းဆုတ်ခွာခဲ့သည်",
  物流详情: "ထောက်ပံ့ပို့ဆောင်ရေးအသေးစိတ်အချက်အလက်များ",
  充值: "ထိပ်တန်း",
  提现: "ဆုတ်ခွာ",
  信用分: "ယုံကြည်ခြင်း",
  余额: "လက်ကျန်ငေှ",
  佣金: "လွှအပ်စာ",
  继续购物: "စျေးဝယ်ဆက်လက်",
  订单结算: "အမိန့်အခြေချ",
  加入对比: "နှိုင်းယှဉ်ထည့်ပါ",
  佣金余额: "ကော်မရှင်လက်ကျန်ငွေ",
  刷新: "အားဖြည့်",
  刷新成功: "အားဖြည့်",
  官网: "တရားဝင်ဝက်ဘ်ဆိုက်",
  税号: "အခွန်နံပါတ်",
  订单: "အမိန့်",
  合计: "လုံးဝသော",
  系统安全: "စနစ်လုံခြုံရေး",
  Recharge_Money_Limit: "ငွေဖြည့်ငွေပမာဏသည် {min} နှင့် {max} အကြားဖြစ်ရမည်။",
  限时优惠: "ကန့်သတ်အချိန်",
  高价回收: "မြင့်မားသော - ပြန်လည်အသုံးပြု",
  姓名: "နံမယ်",
  商品订单号: "ကုန်ပစ္စည်းအမိန့်နံပါတ်",
  商品在线回收: "ကုန်ပစ္စည်းအွန်လိုင်းပြန်လည်အသုံးပြုမှု",
  提交: "နားထောင်",
  回收记录: "ပြန်လည်ထူထောင်ရေးမှတ်တမ်း",
  回收状态: "ပြန်လည်ထူထောင်ရေးအခြေအနေ",
  回收价格: "ပြန်လည်အသုံးပြုစျေးနှုန်း",
  纳税码: "အခွန်ကုဒ်",
  买家登录: "လော့ဂ်အင်",
  买家注册: "စာရင်း",
  language: "တရုတ်",
  助力提示:
    "ကုန်သည်များကိုကူညီခြင်းအားဖြင့်သူတို့၏စတိုးဆိုင်များနှင့်ထိတွေ့မှုနှင့်ထိတွေ့မှုပိုမိုမြင့်မားလေလေ,",
  已累计助力: "cumulative ကူညီပေးခဲ့သည်",
  今日已助力: "ဒီနေ့ကူညီပေးခဲ့တယ်",
  立即助力: "ချက်ချင်းအကူအညီ",
  商家助力: "ကုန်သည်အကူအညီ",
  证件号码: "အိုင်ဒီနံပါတ်",
  证书号码: "လက်မှတ်နံပါတ်"
};
